import React, { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";

interface ExplanatoryCardProps {
  topBody: React.ReactNode;
  hiddenBody?: React.ReactNode;
  expandable?: boolean;
  initialExpanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
  /** "hairline" matches the Vendor List cards: 1px neutral border, 12px radius, 1px/2px shadow. */
  variant?: "default" | "hairline";
}

const ExplanatoryCard = ({
  topBody,
  hiddenBody,
  initialExpanded = false,
  expandable = true,
  onExpandedChange,
  variant = "default",
}: ExplanatoryCardProps) => {
  const [expanded, setExpanded] = useState(initialExpanded);
  const toggleExpanded = () => {
    const next = !expanded;
    setExpanded(next);
    onExpandedChange?.(next);
  };
  return (
    <div
      className={
        variant === "hairline"
          ? "w-full h-fit bg-white border border-solid border-neutral-200 rounded-xl shadow-[0px_1px_2px_0px_#1018280D] p-6 font-roboto mb-6"
          : "w-full h-fit rounded-lg p-6 shadow-[0px_2px_12px_0px_#0000001F] font-roboto mb-6"
      }
    >
      <div className="flex justify-between items-start">
        <div className="flex-1">{topBody}</div>
        {expandable && (
          <button onClick={toggleExpanded} className="cursor-pointer ml-4">
            {expanded ? (
              <ChevronUpIcon className="h-5 w-5" />
            ) : (
              <ChevronDownIcon className="h-5 w-5" />
            )}
          </button>
        )}
      </div>
      {expanded && <div>{hiddenBody}</div>}
      {expandable && (
        <p
          onClick={toggleExpanded}
          className="font-medium text-sm leading-5 underline text-primary-600 cursor-pointer pt-3"
        >
          {expanded ? "Show less" : "Show more"}
        </p>
      )}
    </div>
  );
};

export default ExplanatoryCard;
